<template>
	<input class="form-control" type="text" :value="value" @input="onInput" :_maxlength="mask.length" :placeholder="mask.replace(/[#@]/g, '_')">
</template>

<script>
export default {
	props: [
		'mask',
		'value',
	],
	mounted: function () {
// 		masked = this;
		if(this.value != undefined && this.value != '')
			this.$emit('input', this.maskIt(this.value));
	},
	methods: {
/**
 * Наложение маски на текст
 */
		maskIt: function (v) {
//			v = v.replace(/[^\d]/g, '').split('');
			v = v.split('');
			var m = this.mask.split('');
			var s = '';
			for(var i = 0, j = 0; i < m.length;) {
				if(v[j] == undefined) {
// 					s += m.slice(s.length).join('').replace(/[#@]/g, '_');
					break;
				}
				if(m[i] == v[j]) {
					s += m[i++];
					j++
				} else {
					if(m[i].match(/[^#@%]/))
						s += m[i++];
					else
						if(m[i].match(/[#%]/) && v[j].match(/\d/) || m[i].match(/[@]/) && v[j].match(/[a-zA-Z]+/) || m[i].match(/[%]/) && v[j].match(/[\da-np-zA-NP-Z]+/)) {
							s += v[j++];
							i++;
						} else
							j++;
				}
			}
// 			console.log(s);
			return s.toUpperCase();
		},
		onInput: function (event) {
// 			console.log(this.value);
// 			console.log(event.target.value);
			if(event.target.value.length)
				event.target.value = this.maskIt(event.target.value);
			this.$emit('input', event.target.value);
// 			this.$emit('input', this.maskIt(event.target.value));
		},
	},
};
</script>
